var map = {
	"./calibration-image.png": 6000,
	"./compass-arrow.png": 421,
	"./instructions-background.png": 167,
	"./permissions-background.png": 1655,
	"./sanfrancisco/alcatraz.png": 4673,
	"./sanfrancisco/angel-island.png": 6956,
	"./sanfrancisco/bay-bridge.png": 9574,
	"./sanfrancisco/chase-center.png": 8189,
	"./sanfrancisco/coit-tower.png": 2472,
	"./sanfrancisco/ferry-building.png": 9777,
	"./sanfrancisco/giants-stadium.png": 8510,
	"./sanfrancisco/golden-gate-bridge.png": 8006,
	"./sanfrancisco/palace-fine-arts.png": 9181,
	"./sanfrancisco/sutro-tower.png": 7200,
	"./sanfrancisco/transamerica-building.png": 9544,
	"./sanfrancisco/treasure-island.png": 4889,
	"./tokyo/Asakusa Senso-Ji.png": 5602,
	"./tokyo/Hibiya Park.png": 4258,
	"./tokyo/Imperial Palace.png": 2163,
	"./tokyo/Meji Shrine.png": 3229,
	"./tokyo/Ministry of Justice.png": 4441,
	"./tokyo/Mount Fuji.png": 9953,
	"./tokyo/Shinjuku Gyoen Garden.png": 1975,
	"./tokyo/Tokyo Metropolitan Building.png": 7096,
	"./tokyo/Tokyo Sky Tree.png": 9839,
	"./tokyo/Tokyo Tower.png": 966,
	"./tokyo/Toranomon Hills Mori Tower.png": 721,
	"./tokyo/Toyosu Fish Market.png": 7543
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 319;